import styled from 'styled-components';
import ModalWindow from 'components/modals/ModalWindow';
import { RightArrow } from 'components/admin2/ui/Button';
import {
  ACCENT_PRIMARY,
  SURFACE_3,
  TEXT_100,
  TEXT_CONTRAST_ON_ACCENT_PRIMARY,
} from 'style/constants';
import {
  desktopOnly,
  mobileOnly,
} from 'style/mixins';
import { TextIconButton } from 'components/ui/Button';
import { TEXT_LABEL_M_MEDIUM, TEXT_LABEL_XS_MEDIUM } from 'style/design-system/textStyles';
import { SUBMIT } from 'injection-classes';

// gdpr
export const StyledModalWindow = styled(ModalWindow)<{
  adminbarWidth: number;
  sidebarWidth: number;
}>`
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 100;
  padding: 0;
  display: flex;
  justify-content: center;
  background: transparent;
  ${desktopOnly`
    transition: margin-right 0.5s, margin-left 0.5s;
    margin-right: ${({ sidebarWidth }) => sidebarWidth}px;
    margin-left: ${({ adminbarWidth = 0 }) => adminbarWidth}px;
  `}
`;

export const Container = styled.div<{ state: string; }>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background:${SURFACE_3};
  display: flex;
  min-height: 62px;
  width: max-content;
  padding: 10px 16px 10px 34px;
  border-radius: 10px 10px 0 0;
  margin-bottom: ${({ state }) => state === 'entered' ? 0 : -200}px;
  transition: margin-bottom 0.5s;
  box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.15);
  margin: 0 33px;
  ${mobileOnly`
    margin: 0 10px;
    flex-direction: column;
    height: auto;
    padding: 16px;
  `}
`;

export const TextWrapper = styled.div`
  ${TEXT_LABEL_M_MEDIUM}
  color: ${TEXT_100};
  display: flex;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  max-height: 40px;
  overflow: hidden;
  ${mobileOnly`
    margin-top: 10px;
  `}
`;

export const AcceptButton = styled(TextIconButton).attrs(props => ({
  className: SUBMIT,
  color: TEXT_CONTRAST_ON_ACCENT_PRIMARY(props),
  icon: 'cookie',
  kind: 'large',
  labelKey: 'ACTION_ACCEPT_TERMS',
}))`
  ${TEXT_LABEL_XS_MEDIUM}
  & div {
    color: ${TEXT_CONTRAST_ON_ACCENT_PRIMARY} !important;
  }

  & svg path {
    fill: ${TEXT_CONTRAST_ON_ACCENT_PRIMARY} !important;
  }
  height: 40px;
  width: 191px;
`;

export const ArrowIcon = styled(RightArrow).attrs(props => ({
  color: ACCENT_PRIMARY(props),
}))`
  cursor: default;
`;

